import { render } from "./Modal.vue?vue&type=template&id=80422310&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=80422310&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80422310"],['__file',"src/components/mdbvue/Modals/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80422310"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80422310', __exports__)) {
    api.reload('80422310', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=80422310&scoped=true", () => {
    api.rerender('80422310', render)
  })

}


export default __exports__